/* =========================================================
   Vurozen — Premium Cart JS v5
   Fixes: recently-viewed tracker, favorites mixed format,
          for-you sessionStorage cache, notification persistence
   ========================================================= */
(function () {
  'use strict';

  var cartRoot = document.querySelector('.hw-cart');
  if (!cartRoot) return;

  var threshold  = Number(cartRoot.dataset.freeShippingThreshold || 7500);
  var savedKey   = 'hw40_saved_for_later';
  var wishKey    = 'hw40_wishlist';
  var recentKey  = 'hw40_recently_viewed';
  var foryouKey  = 'hw40_foryou_cache';       /* sessionStorage — estable entre reloads */
  var notifKey   = 'hw40_pending_notif';      /* sessionStorage — notificación tras reload */
  var FORYOU_TTL = 30 * 60 * 1000;           /* 30 min */

  /* --- Header clearance --- */
  (function () {
    var hdr = document.querySelector('.hw40-hdr');
    if (hdr) {
      var h = hdr.offsetHeight;
      if (h > 0) cartRoot.style.paddingTop = (h + 8) + 'px';
    }
  })();

  /* =========================================================
     MONEY HELPERS
     ========================================================= */
  /* cents → "$X.XX" (cart API devuelve centavos) */
  function money(cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  /* string dólares → "$X.XX" (REST product/collection API devuelve "49.99") */
  function moneyStr(str) {
    if (typeof str === 'string' && str.indexOf('$') >= 0) return str; /* ya formateado */
    var n = parseFloat(str);
    if (isNaN(n)) return str || '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  /* Normaliza URL de imagen: // → https:// */
  function imgUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  /* =========================================================
     CART API
     ========================================================= */
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function (r) { if (!r.ok) throw new Error('Cart error'); return r.json(); });
  }
  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) })
    }).then(function (r) { if (!r.ok) throw new Error('Add error'); return r.json(); });
  }

  /* =========================================================
     UI UPDATES
     ========================================================= */
  function updateHeader(cart) {
    var n = cart.item_count;
    var countEl = qs('[data-cart-count]');
    if (countEl) countEl.textContent = '(' + n + ' ' + (n === 1 ? 'item' : 'items') + ')';

    var p = cart.total_price;
    ['[data-cart-subtotal]','[data-cart-total]','[data-pb-subtotal]','[data-pb-total]','[data-ms-total]']
      .forEach(function (s) { var el = qs(s); if (el) el.textContent = money(p); });

    var inst = Math.ceil(p / 4);
    ['[data-installment-price]','[data-pb-installment]']
      .forEach(function (s) { var el = qs(s); if (el) el.textContent = money(inst); });
  }

  var SUCCESS_MSG = 'You earned Free Standard Shipping!';

  /* Icono pequeño para mobile sticky */
  var MS_SHIP_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" fill="none" viewBox="0 0 23 18" style="vertical-align:middle;margin-right:4px" aria-hidden="true"><g stroke="#256923" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"><path d="M15.664 16.3a1 1 0 01-.84.025l-6.966-2.973a1 1 0 01-.608-.92V5.643a1 1 0 01.577-.906l6.531-3.048a1 1 0 01.794-.022l6.469 2.588a1 1 0 01.629.928v7.205a1 1 0 01-.553.894L15.664 16.3z"/><path d="M15.25 8.006L22.062 4.6"/><path d="M7.428 5.074l7.82 2.933v8.397"/><path d="M18.48 6.39l-7.383-3.18"/><path d="M.75 9.877l.047.02 3.953 1.827"/><path d="M2.382 7.13L4.75 8.225"/><path d="M3.623 4.203l1.127.52"/></g></svg>';

  function updateShipping(cart) {
    var total     = cart.total_price;
    var remaining = Math.max(threshold - total, 0);
    var pct       = Math.min((total / threshold) * 100, 100);
    var unlocked  = remaining === 0;

    var pendingMsg = "You're just <strong>" + money(remaining) + "</strong> away from Free Shipping!";

    /* ── Shipping bar principal (dentro de hw-cart__shipping-zone) ── */
    var msg = qs('[data-shipping-message]');
    var bar = qs('[data-shipping-progress]');
    if (msg) msg.innerHTML = unlocked ? SUCCESS_MSG : pendingMsg;
    if (bar) bar.style.width = pct + '%';

    /* ── Mobile sticky bar ── */
    var msFill  = qs('[data-ms-fill]');
    var msText  = qs('[data-ms-ship-text]');
    var msTrack = qs('.hw-cart__ms-track');
    var msAdd   = qs('.hw-cart__ms-add');
    if (msFill) msFill.style.width = pct + '%';

    if (unlocked) {
      /* Mobile: oculta barra de progreso y botón "+ Add items", muestra icono + texto */
      if (msTrack) msTrack.style.display = 'none';
      if (msAdd)   msAdd.style.display   = 'none';
      if (msText)  msText.innerHTML = MS_SHIP_ICON + SUCCESS_MSG;
    } else {
      if (msTrack) msTrack.style.display = '';
      if (msAdd)   msAdd.style.display   = '';
      if (msText)  msText.innerHTML = pendingMsg;
    }

    /* ── "Don't Miss Free Shipping" CTA ── */
    var unlockCta = qs('[data-unlock-cta]');
    var leftCol   = qs('.hw-cart__left');
    if (!unlockCta) return;

    unlockCta.removeAttribute('hidden');

    var itemsEl = qs('.hw-cart__items');

    if (unlocked) {
      /* Desbloqueado: pasa unlock-cta justo debajo de MY BAG (donde estaba la shipping zone) */
      unlockCta.classList.add('is-unlocked');
      if (leftCol) leftCol.classList.add('shipping-unlocked');
      var pageHdr = qs('.hw-cart__page-header', leftCol);
      if (pageHdr && pageHdr.parentNode) {
        pageHdr.parentNode.insertBefore(unlockCta, pageHdr.nextSibling);
      }
      var headline = qs('[data-unlock-headline]');
      var subMsg   = qs('[data-unlock-msg]');
      var btn      = qs('[data-add-items-btn]', unlockCta);
      if (headline) headline.textContent = SUCCESS_MSG;
      if (subMsg)   subMsg.textContent   = '';
      if (btn)      btn.style.display    = 'none';
    } else {
      /* Pendiente: aspecto normal, devuelve unlock-cta a su posición original (después de items) */
      unlockCta.classList.remove('is-unlocked');
      if (leftCol) leftCol.classList.remove('shipping-unlocked');
      if (itemsEl && itemsEl.parentNode) {
        itemsEl.parentNode.insertBefore(unlockCta, itemsEl.nextSibling);
      }
      var headline2 = qs('[data-unlock-headline]');
      var subMsg2   = qs('[data-unlock-msg]');
      var btn2      = qs('[data-add-items-btn]', unlockCta);
      if (headline2) headline2.textContent = "Don't Miss Free Shipping!";
      if (subMsg2)   subMsg2.innerHTML     = "You're <strong>" + money(remaining) + "</strong> away — add more items to unlock Free Shipping.";
      if (btn2)      btn2.style.display    = '';
    }
  }

  /* =========================================================
     SHARE MODAL
     ========================================================= */
  function generateShareUrl(cart) {
    if (!cart || !cart.items || !cart.items.length) return window.location.origin + '/cart';
    var s = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
    return window.location.origin + '/pages/shared-cart?items=' + encodeURIComponent(s);
  }
  function populateShareLinks(url) {
    var inp = qs('[data-share-url]');
    var fb  = qs('[data-share-facebook]');
    var pin = qs('[data-share-pinterest]');
    var tw  = qs('[data-share-twitter]');
    if (inp) inp.value = url;
    if (fb)  fb.href  = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    if (pin) pin.href = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url);
    if (tw)  tw.href  = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url);
  }
  function openShareModal() {
    getCart().then(function (cart) {
      populateShareLinks(generateShareUrl(cart));
      var o = qs('[data-share-overlay]'), m = qs('[data-share-modal]');
      if (o) o.removeAttribute('hidden');
      if (m) m.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeShareModal() {
    var o = qs('[data-share-overlay]'), m = qs('[data-share-modal]');
    if (o) o.setAttribute('hidden', '');
    if (m) m.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  /* =========================================================
     PRICE BREAKDOWN
     ========================================================= */
  function openPriceBreakdown() {
    var o = qs('[data-pb-overlay]'), s = qs('[data-pb-sheet]');
    if (o) o.removeAttribute('hidden');
    if (s) s.removeAttribute('hidden');
  }
  function closePriceBreakdown() {
    var o = qs('[data-pb-overlay]'), s = qs('[data-pb-sheet]');
    if (o) o.setAttribute('hidden', '');
    if (s) s.setAttribute('hidden', '');
  }

  /* =========================================================
     LOCALSTORAGE / SESSIONSTORAGE HELPERS
     ========================================================= */
  function getSaved()    { try { return JSON.parse(localStorage.getItem(savedKey))  || []; } catch (e) { return []; } }
  function setSaved(d)   { localStorage.setItem(savedKey,  JSON.stringify(d)); }
  function getWishlist() { try { return JSON.parse(localStorage.getItem(wishKey))   || []; } catch (e) { return []; } }
  function setWishlist(d){ localStorage.setItem(wishKey,   JSON.stringify(d)); window.dispatchEvent(new CustomEvent('hw40:wishlist:updated')); }
  function getRecent()   { try { return JSON.parse(localStorage.getItem(recentKey)) || []; } catch (e) { return []; } }

  function getCachedForYou() {
    try {
      var c = JSON.parse(sessionStorage.getItem(foryouKey) || 'null');
      if (c && (Date.now() - c.ts) < FORYOU_TTL) return c.products;
    } catch (e) {}
    return null;
  }
  function setCachedForYou(products) {
    try { sessionStorage.setItem(foryouKey, JSON.stringify({ products: products, ts: Date.now() })); } catch (e) {}
  }

  /* =========================================================
     SAVE FOR LATER — NOTIFICATION PERSISTENCE
     ========================================================= */
  function showSaveNotification(title) {
    var note = qs('[data-save-notification]');
    if (!note) {
      note = document.createElement('div');
      note.className = 'hw-cart__save-notification';
      note.dataset.saveNotification = '';
      var itemsEl = qs('[data-cart-items]');
      if (itemsEl && itemsEl.parentNode) itemsEl.parentNode.insertBefore(note, itemsEl.nextSibling);
    }
    note.innerHTML = '<strong>' + title + '</strong> has been moved to your <a href="#hw-cart-recs">Saved for Later</a>';
    note.classList.add('is-visible');
    setTimeout(function () { note.classList.remove('is-visible'); }, 8000);
  }

  /* Restaura notificación pendiente tras reload */
  function restorePendingNotification() {
    try {
      var pending = sessionStorage.getItem(notifKey);
      if (pending) {
        sessionStorage.removeItem(notifKey);
        /* Pequeño delay para que el DOM esté listo */
        setTimeout(function () { showSaveNotification(pending); }, 300);
      }
    } catch (e) {}
  }

  function saveItemForLater(itemEl) {
    var title     = itemEl.dataset.title     || '';
    var url       = itemEl.dataset.url       || '#';
    var image     = itemEl.dataset.image     || '';
    var price     = itemEl.dataset.price     || '';
    var variantId = itemEl.dataset.variantId;
    var line      = Number(itemEl.dataset.line);

    /* Guardar en Saved for Later (objetos) */
    var saved = getSaved();
    if (!saved.some(function (s) { return String(s.variantId) === String(variantId); })) {
      saved.push({ title: title, url: url, image: image, price: price, variantId: variantId, quantity: 1 });
      setSaved(saved);
    }

    /* Guardar en Wishlist como objeto (compatible con loadFavorites) */
    addToWishlistObj({ variantId: variantId, title: title, image: image, url: url, price: price });

    /* Persistir notificación en sessionStorage ANTES del reload */
    try { sessionStorage.setItem(notifKey, title); } catch (e) {}

    changeLine(line, 0).then(function () { window.location.reload(); });
  }

  /* =========================================================
     WISHLIST — soporte para AMBOS formatos:
     - Array de strings ['handle1', 'handle2']  (hw4-black-product.js)
     - Array de objetos [{variantId, title, image, url, price}]  (nuestro sistema)
     ========================================================= */

  /* Normaliza un item del wishlist: string handle → objeto enriquecido via API */
  function normalizeWishlistItem(item, callback) {
    if (typeof item === 'object' && item !== null && item.variantId) {
      callback(item);
      return;
    }
    /* item es un string (handle) — obtener datos del producto */
    var handle = String(item);
    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.product) { callback(null); return; }
        var p   = data.product;
        var v   = p.variants && p.variants[0];
        var img = p.images && p.images[0] && p.images[0].src || '';
        callback({
          variantId: v ? String(v.id) : '',
          title:     p.title || '',
          url:       '/products/' + p.handle,
          image:     img,
          price:     moneyStr(v ? v.price : '0'),
          handle:    p.handle
        });
      })
      .catch(function () { callback(null); });
  }

  /* Agrega al wishlist como objeto (no duplica) */
  function addToWishlistObj(obj) {
    var wish = getWishlist();
    /* Normalizar array existente para comparar por handle/variantId */
    var vid = String(obj.variantId || '');
    var handle = obj.handle || obj.url && obj.url.replace('/products/', '') || '';
    var exists = wish.some(function (w) {
      if (typeof w === 'string') return w === handle;
      return String(w.variantId) === vid || w.handle === handle;
    });
    if (!exists) {
      wish.push(Object.assign({ addedAt: Date.now() }, obj));
      setWishlist(wish);
    }
  }

  /* =========================================================
     RENDER SAVED FOR LATER
     ========================================================= */
  function renderSaved() {
    var section   = qs('[data-saved-section]');
    var container = qs('[data-saved-items]');
    var countEl   = qs('[data-saved-count]');
    if (!section || !container) return;

    var saved = getSaved();
    if (!saved.length) { section.setAttribute('hidden', ''); container.innerHTML = ''; return; }

    section.removeAttribute('hidden');
    if (countEl) countEl.textContent = '(' + saved.length + ')';

    container.innerHTML = saved.map(function (item, i) {
      return '<article class="hw-cart__saved-item" data-saved-index="' + i + '">'
        + '<img src="' + imgUrl(item.image || '') + '" alt="" loading="lazy" width="72" height="108">'
        + '<div class="hw-cart__saved-item-info">'
        + '<a href="' + (item.url || '#') + '" class="hw-cart__saved-item-title">' + (item.title || '') + '</a>'
        + '<p class="hw-cart__saved-item-price">' + (item.price || '') + '</p>'
        + '<div class="hw-cart__saved-item-actions">'
        + '<button type="button" class="hw-cart__delete-btn" data-delete-saved>Delete</button>'
        + '<button type="button" class="hw-cart__move-btn" data-move-saved>Move to Bag</button>'
        + '</div>'
        + '</div>'
        + '<div class="hw-cart__delete-popup" data-delete-popup>'
        + '<p>Are you sure?</p>'
        + '<div class="hw-cart__delete-popup-btns">'
        + '<button type="button" class="hw-cart__dp-remove" data-confirm-remove>Remove</button>'
        + '<button type="button" class="hw-cart__dp-wishlist" data-confirm-wishlist>Move to Wishlist</button>'
        + '</div>'
        + '</div>'
        + '</article>';
    }).join('');
  }

  function moveSavedToBag(index) {
    var saved = getSaved();
    var item  = saved[index];
    if (!item) return;
    addItem(item.variantId, item.quantity || 1).then(function () {
      saved.splice(index, 1);
      setSaved(saved);
      window.location.reload();
    });
  }
  function permanentlyRemoveSaved(index) {
    var saved = getSaved(); saved.splice(index, 1); setSaved(saved); renderSaved();
  }
  function moveToWishlist(index) {
    var saved = getSaved();
    var item  = saved[index];
    if (!item) return;
    addToWishlistObj(item);
    saved.splice(index, 1); setSaved(saved);
    renderSaved(); loadFavorites();
  }

  /* =========================================================
     ATC SVG ICON (compartido)
     ========================================================= */
  var ATC_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512">'
    + '<path d="M0 0h512v512H0z" fill="none"/>'
    + '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"'
    + ' d="M256 256v128m64-64H192M80 176a16 16 0 0 0-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 0 0-16-16Zm80 0v-32a96 96 0 0 1 96-96h0a96 96 0 0 1 96 96v32"/>'
    + '</svg>';

  /* =========================================================
     BUILD REC CARD (For You / Recently Viewed)
     ========================================================= */
  function recCardHtml(p) {
    var img       = imgUrl(p.image || (p.images && p.images[0] && p.images[0].src) || '');
    var url       = p.url || (p.handle ? '/products/' + p.handle : '#');
    var variantId = p.variantId || (p.variants && p.variants[0] && p.variants[0].id) || '';
    var price     = moneyStr(p.price || (p.variants && p.variants[0] && p.variants[0].price) || '');

    var atcBtn = variantId
      ? '<button type="button" class="hw-cart__rec-atc" data-rec-variant="' + variantId + '" aria-label="Add to bag">'
        + ATC_SVG + '</button>'
      : '';

    return '<a href="' + url + '" class="hw-cart__rec-card">'
      + (img ? '<img src="' + img + '" alt="" class="hw-cart__rec-card-img" loading="lazy" width="200" height="300">'
             : '<div class="hw-cart__rec-card-img"></div>')
      + '<div class="hw-cart__rec-card-info">'
      + '<span class="hw-cart__rec-price">' + price + '</span>'
      + '</div>'
      + '</a>'
      + atcBtn;
  }

  function wrapRec(inner) {
    return '<div style="position:relative">' + inner + '</div>';
  }

  /* =========================================================
     FOR YOU — con caché sessionStorage para estabilidad
     ========================================================= */
  function loadRecommendations() {
    var recsEl = qs('[data-recs-foryou]');
    if (!recsEl) return;

    /* Usar caché si está vigente */
    var cached = getCachedForYou();
    if (cached && cached.length) {
      recsEl.innerHTML = cached.map(function (p) { return wrapRec(recCardHtml(p)); }).join('');
      return;
    }

    recsEl.innerHTML = '<p class="hw-cart__recs-loading">Loading…</p>';

    /* Colecciones de productos vistos recientemente */
    var recent  = getRecent();
    var handles = [];
    recent.forEach(function (p) {
      if (p.collections) p.collections.forEach(function (c) {
        if (handles.indexOf(c) === -1) handles.push(c);
      });
    });

    var firstCartItem = document.querySelector('.hw-cart__item');
    var productId     = firstCartItem ? firstCartItem.dataset.productId : null;

    function renderProducts(products) {
      if (!products || !products.length) {
        recsEl.innerHTML = '<p class="hw-cart__recs-empty">Browse our <a href="/collections/all">collection</a>.</p>';
        return;
      }
      var items = products.slice(0, 4);
      setCachedForYou(items); /* cachear para estabilidad */
      recsEl.innerHTML = items.map(function (p) { return wrapRec(recCardHtml(p)); }).join('');
    }

    if (handles.length > 0) {
      fetch('/collections/' + handles[0] + '/products.json?limit=8&sort_by=best-selling')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.products && data.products.length) renderProducts(data.products);
          else if (productId) tryRecsAPI(productId, recsEl, renderProducts);
          else fallbackBestSellers(recsEl, renderProducts);
        })
        .catch(function () {
          if (productId) tryRecsAPI(productId, recsEl, renderProducts);
          else fallbackBestSellers(recsEl, renderProducts);
        });
    } else if (productId) {
      tryRecsAPI(productId, recsEl, renderProducts);
    } else {
      fallbackBestSellers(recsEl, renderProducts);
    }
  }

  function tryRecsAPI(productId, el, renderFn) {
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.products && data.products.length) renderFn(data.products);
        else fallbackBestSellers(el, renderFn);
      })
      .catch(function () { fallbackBestSellers(el, renderFn); });
  }

  function fallbackBestSellers(el, renderFn) {
    fetch('/collections/all/products.json?limit=4&sort_by=best-selling')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.products && data.products.length) renderFn(data.products);
        else el.innerHTML = '<p class="hw-cart__recs-empty">Explore our <a href="/collections/all">full collection</a>.</p>';
      })
      .catch(function () {
        el.innerHTML = '<p class="hw-cart__recs-empty">Explore our <a href="/collections/all">full collection</a>.</p>';
      });
  }

  /* =========================================================
     RECENTLY VIEWED — lee hw40_recently_viewed del tracker
     ========================================================= */
  function loadRecentlyViewed() {
    var recentEl = qs('[data-recs-recently]');
    if (!recentEl) return;

    var recent = getRecent().slice(0, 4);
    if (!recent.length) {
      recentEl.innerHTML = '<p class="hw-cart__recs-empty">Products you view will appear here.</p>';
      return;
    }
    recentEl.innerHTML = recent.map(function (p) { return wrapRec(recCardHtml(p)); }).join('');
  }

  /* =========================================================
     FAVORITES — soporta AMBOS formatos del wishlist:
     - string handles  (hw4-black-product.js)
     - objetos         (save for later / nuestro sistema)
     ========================================================= */
  function loadFavorites() {
    var favEl = qs('[data-recs-favorites]');
    if (!favEl) return;

    var raw = getWishlist();
    if (!raw.length) {
      favEl.innerHTML = '<p class="hw-cart__recs-empty">Items you save will appear here.</p>';
      return;
    }

    favEl.innerHTML = '<p class="hw-cart__recs-loading">Loading…</p>';

    /* Separar objetos ya completos de strings que necesitan fetch */
    var objects  = [];
    var handles  = [];
    var handleIdx = {};

    raw.forEach(function (item) {
      if (typeof item === 'string') {
        handleIdx[item] = handles.length;
        handles.push(item);
      } else if (item && item.variantId) {
        objects.push(item);
      } else if (item && item.handle) {
        handleIdx[item.handle] = handles.length;
        handles.push(item.handle);
      }
    });

    if (!handles.length) {
      /* Todos son objetos completos — render directo */
      renderFavCards(objects.slice(0, 4), favEl);
      return;
    }

    /* Fetch para los handles que no tienen datos */
    var fetched = [];
    var pending = handles.length;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.product) {
            var p  = data.product;
            var v  = p.variants && p.variants[0];
            var im = p.images && p.images[0] && p.images[0].src || '';
            fetched[handleIdx[handle]] = {
              variantId: v ? String(v.id) : '',
              title:     p.title || '',
              url:       '/products/' + p.handle,
              image:     im,
              price:     moneyStr(v ? v.price : '0'),
              handle:    p.handle
            };
          }
        })
        .catch(function () {})
        .finally(function () {
          pending--;
          if (pending === 0) {
            var all = objects.concat(fetched.filter(Boolean)).slice(0, 4);
            renderFavCards(all, favEl);
          }
        });
    });
  }

  function renderFavCards(items, favEl) {
    if (!items.length) {
      favEl.innerHTML = '<p class="hw-cart__recs-empty">Items you save will appear here.</p>';
      return;
    }
    favEl.innerHTML = items.map(function (item) {
      var img       = imgUrl(item.image || '');
      var price     = moneyStr(item.price || '');
      var variantId = item.variantId || '';

      return '<div class="hw-cart__fav-card" style="position:relative">'
        + '<div class="hw-cart__fav-img-wrap">'
        + (img ? '<img src="' + img + '" alt="" class="hw-cart__fav-img" loading="lazy" width="200" height="300">'
               : '<div class="hw-cart__fav-img"></div>')
        + (variantId
          ? '<button type="button" class="hw-cart__fav-atc" data-rec-variant="' + variantId + '" aria-label="Add to bag">'
            + ATC_SVG + '</button>'
          : '')
        + '</div>'
        + '<div class="hw-cart__fav-info">'
        + '<span class="hw-cart__fav-price">' + price + '</span>'
        + '</div>'
        + '</div>';
    }).join('');
  }

  function removeFromWishlist(index) {
    var wish = getWishlist();
    wish.splice(index, 1);
    setWishlist(wish);
    loadFavorites();
  }

  /* =========================================================
     ADD ITEMS BUTTON — scroll o link a colección
     ========================================================= */
  function handleAddItemsClick(e) {
    var recsEl = document.getElementById('hw-cart-recs');
    if (!recsEl) return;
    var recent = getRecent();
    var wish   = getWishlist();
    var cards  = recsEl.querySelectorAll('.hw-cart__rec-card, .hw-cart__fav-card');
    if (recent.length > 0 || wish.length > 0 || cards.length > 0) {
      e.preventDefault();
      recsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* =========================================================
     TABS
     ========================================================= */
  function setupTabs() {
    var tabs = document.querySelectorAll('[data-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        document.querySelectorAll('[data-tab-panel]').forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        var panel = document.querySelector('[data-tab-panel="' + tab.dataset.tab + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* =========================================================
     EVENTS
     ========================================================= */
  function setupEvents() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var itemEl = t.closest('.hw-cart__item');

      if (t.matches('[data-qty-plus]') && itemEl) {
        e.preventDefault();
        var inp = itemEl.querySelector('[data-qty-input]');
        changeLine(itemEl.dataset.line, Number(inp.value || 1) + 1).then(function () { window.location.reload(); });
        return;
      }
      if (t.matches('[data-qty-minus]') && itemEl) {
        e.preventDefault();
        var inp2 = itemEl.querySelector('[data-qty-input]');
        changeLine(itemEl.dataset.line, Math.max(Number(inp2.value || 1) - 1, 0)).then(function () { window.location.reload(); });
        return;
      }
      if (t.matches('[data-save-later]') && itemEl) { saveItemForLater(itemEl); return; }

      if (t.matches('[data-move-saved]')) {
        var si = t.closest('[data-saved-index]'); if (si) moveSavedToBag(Number(si.dataset.savedIndex)); return;
      }
      if (t.matches('[data-delete-saved]')) {
        var si2 = t.closest('[data-saved-index]'); if (!si2) return;
        document.querySelectorAll('.hw-cart__delete-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
        var popup = si2.querySelector('[data-delete-popup]');
        if (popup) popup.classList.toggle('is-open'); return;
      }
      if (t.matches('[data-confirm-remove]')) {
        var si3 = t.closest('[data-saved-index]'); if (si3) permanentlyRemoveSaved(Number(si3.dataset.savedIndex)); return;
      }
      if (t.matches('[data-confirm-wishlist]')) {
        var si4 = t.closest('[data-saved-index]'); if (si4) moveToWishlist(Number(si4.dataset.savedIndex)); return;
      }

      /* ATC en rec/fav cards */
      var rb = t.matches('[data-rec-variant]') ? t : t.closest('[data-rec-variant]');
      if (rb) {
        var vid = rb.dataset.recVariant;
        if (vid) { rb.disabled = true; addItem(vid, 1).then(function () { window.location.reload(); }).catch(function () { rb.disabled = false; }); }
        return;
      }

      if (t.matches('[data-share-cart]') || t.closest('[data-share-cart]')) { openShareModal(); return; }
      if (t.matches('[data-share-close]') || t.matches('[data-share-overlay]')) { closeShareModal(); return; }
      if (t.matches('[data-copy-share]')) {
        var urlInp = qs('[data-share-url]'); if (!urlInp) return;
        urlInp.select();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(urlInp.value).then(function () {
            t.textContent = 'Copied!'; setTimeout(function () { t.textContent = 'Copy URL'; }, 1800);
          });
        } else { document.execCommand('copy'); t.textContent = 'Copied!'; setTimeout(function () { t.textContent = 'Copy URL'; }, 1800); }
        return;
      }

      var tb = t.matches('[data-ms-total-toggle]') ? t : t.closest('[data-ms-total-toggle]');
      if (tb) { tb.classList.toggle('is-open'); openPriceBreakdown(); return; }
      if (t.matches('[data-pb-close]') || t.matches('[data-pb-overlay]')) {
        closePriceBreakdown();
        var tb2 = qs('[data-ms-total-toggle]'); if (tb2) tb2.classList.remove('is-open'); return;
      }
      if (t.matches('[data-add-items-btn]') || t.closest('[data-add-items-btn]')) { handleAddItemsClick(e); return; }
      if (t.matches('[data-apply-discount]')) {
        var ci = qs('[data-discount-input]'); var code = ci ? ci.value.trim() : '';
        if (code) window.location.href = '/checkout?discount=' + encodeURIComponent(code); return;
      }
      if (t.matches('[data-checkout-button]')) { window.location.href = '/checkout'; return; }

      if (!t.closest('[data-delete-popup]') && !t.matches('[data-delete-saved]')) {
        document.querySelectorAll('.hw-cart__delete-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var ie = e.target.closest('.hw-cart__item'); if (!ie) return;
      changeLine(ie.dataset.line, Math.max(Number(e.target.value || 0), 0)).then(function () { window.location.reload(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeShareModal(); closePriceBreakdown();
        document.querySelectorAll('.hw-cart__delete-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      }
    });
  }

  /* =========================================================
     INIT
     ========================================================= */
  function init() {
    getCart().then(function (cart) {
      updateHeader(cart);
      updateShipping(cart);
    });
    restorePendingNotification(); /* 👈 restaura notificación antes que cualquier otra cosa */
    renderSaved();
    loadRecommendations();
    loadRecentlyViewed();
    loadFavorites();
    setupTabs();
    setupEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
